export default "__VITE_ASSET__Dc7gstkm__"